export const ROUTESLIST = {
    HOME: "/",
    SERVICES: "/services",
    SAMPLE: "/sample",
    INTEREST: "/interest",
    SEARCH: "/search",
    SIGNUP: "/signup",
    LOGIN: "/login",
    ADD_CRATE: "/add-crate",
    ALBOM: "/albom",
    CLEAR_SAMPLE: "/clear-sample",
    SUBSCRIPTION: "/subscription/:plan",
    SUBSCRIPTIONS: "/subscriptions",
    PACKAGE: "/membership/:id",
    PACKAGES: "/memberships",
    CART: "/cart",
    CHECKOUT: "/checkout",
    /** Public (unauthenticated) membership checkout – pay first, then user created on success */
    CHECKOUT_MEMBERSHIP: "/memberships/checkout",
    CHECKOUT_MEMBERSHIP_SUCCESS: "/memberships/checkout/success",
    /** In-place membership checkout (Stripe form on page, same pattern as logged-in checkout) */
    CHECKOUT_MEMBERSHIP_IN_PLACE: "/memberships/checkout/form",
    CONGRATS: "/congratulation",
    BILLING_HISTORY: "/billing-history",
    AFTER_REGISTER: "/register/success",
    EMAIL_VERIFY: "/verify/success",
    //crates
    CRATES: "/crates",
    CRATES_CRATE: "/crate/",
    CRATES_SAMPLED: "/crate-sample/",
    //'CRATE' : '/crate/',
    //dashboard
    DASHBOARD: "/dashboard",
    DASHBOARD_TRANSACTIONS: "/userdashboard/transactions/",
    DASHBOARD_SETTINGS: "/userdashboard/settings/",
    DASHBOARD_SAMPLES: "/userdashboard/mysamples",
    DASHBOARD_ONE_SAMPLE: "/userdashboard/samples/",
    DASHBOARD_SYNC: "/userdashboard/mysyncs",
    DASHBOARD_ONE_SYNC: "/userdashboard/sync-detail/",
    DASHBOARD_MECHANICAL: "/dashboard/mechanical",
    DASHBOARD_PROFILE: "/dashboard/profile",
    DASHBOARD_PAYMENTS: "/dashboard/payments",
    DASHBOARD_SECURITY: "/userdashboard/security",
    DASHBOARD_INVOICES: "/dashboard/invoices",
    DASHBOARD_INVOICE: "/dashboard/invoices/",
    DASHBOARD_CRATES: "/dashboard/crates",
    //forms
    UPLOAD_SAMPLE: "/upload/sample",
    UPLOAD_SYNC: "/upload/sync",
    UPLOAD_MECH: "/upload/mech",
    UPLOAD_ADD_CRATE: "/add-crate",
    UPLOAD_ADD_CRATE_SAMPLE: "/add-crate/",
    UPLOAD_REVIEW: "/upload/review",
    UPLOAD_DIGITAL_LICENSE: '/upload/digital_license',

    //account
    ACCOUNT_FORGOT_PASSWORD: "/account/forgot-password",
    ACCOUNT_RESET_PASSWORD: "/reset-password/",
    ACCOUNT_CHANGE_PASSWORD: "/account/change-password",
    //static pages
    STATIC_TERMS: "/terms-and-conditions",
    STATIC_CONTACT: "/contact",
    STATIC_TESTIMONIALS: "/testimonials",
    CLOSED_PAGE: "/pages/",
    FAQ: "/",
    PLAYER: "/player",
};
